import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function EngineHeader({
  activePage = "",
  selectedDate,
  setSelectedDate,
}) {
  const [utcTime, setUtcTime] = useState("");

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const h = String(now.getUTCHours()).padStart(2, "0");
      const m = String(now.getUTCMinutes()).padStart(2, "0");
      const s = String(now.getUTCSeconds()).padStart(2, "0");
      setUtcTime(`${h}:${m}:${s}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const navItems = [
    { label: "Main Engine", to: "/equip2" },
    { label: "Auxiliary Engine", to: "/auxiliaryEngine1" },
    { label: "Alerts", to: null },
    { label: "Alarms", to: "/alarms", badge: 10, badgeColor: "#ef4444" },
    { label: "Cargo", to: "/monitor" },
    { label: "CCTV", to: null },
    { label: "Status", to: null },
    { label: "Master", to: null },
  ];

  return (
    <div className="eh-root">
      {/* LEFT: Title + Vessel + Date */}
      <div className="eh-left">
        <span className="eh-title">Equipment Overview</span>
         {/* Vessel Dropdown */}

        <div className="em-vessel-dropdown-wrapper">
          <select className="em-vessel-dropdown">
            <option value="ark-prestige">
              ARK Prestige
            </option>

            <option value="vessel1">
              Vessel 1
            </option>

            <option value="vessel2">
              Vessel 2
            </option>

            <option value="vessel3">
              Vessel 3
            </option>
          </select>

          {/* <span className="em-vessel-arrow">
            ▾
          </span> */}
        </div>
        <div className="eh-date-wrap">
          <input
            type="date"
            className="eh-date"
            value={selectedDate}
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
          {/* <span className="eh-cal-icon">📅</span> */}
        </div>
      </div>

      {/* CENTER NAV */}
      <nav className="eh-nav">
        {navItems.map(({ label, to, badge, badgeColor }) => (
          <div className="eh-nav-item-wrap" key={label}>
            {to ? (
              <Link
                to={to}
                className={`eh-nav-item${activePage === label ? " active" : ""}`}
              >
                {label}
              </Link>
            ) : (
              <span className={`eh-nav-item${activePage === label ? " active" : ""}`}>
                {label}
              </span>
            )}
            {badge && (
              <span
                className="eh-badge"
                style={{ background: badgeColor || "#ef4444" }}
              >
                {badge}
              </span>
            )}
          </div>
        ))}
      </nav>

      {/* RIGHT: Badges + User + UTC */}
      <div className="eh-right">
        {/* <span className="eh-cnt-badge eh-cnt-red">10</span>
        <span className="eh-cnt-badge eh-cnt-yellow">19</span> */}
        <span className="eh-utc">UTC : {utcTime}</span>
      </div>

      <style>{`
        .eh-root {
          display: flex;
          align-items: center;
          padding: 0 20px;
          height: 52px;
          background: #fff;
          border-bottom: 1px solid #e8edf3;
          gap: 16px;
        }
        .eh-left {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-shrink: 0;
        }
        .eh-title {
          font-size: 15px;
          font-weight: 700;
          color: #1a2332;
          white-space: nowrap;
        }
        .eh-vessel {
          font-size: 13px;
          color: #6b7a90;
          font-weight: 500;
          white-space: nowrap;
        }
        .eh-date-wrap {
          position: relative;
          display: flex;
          align-items: center;
        }
        .eh-date {
          border: 1.5px solid #d0d9e6;
          border-radius: 6px;
          padding: 4px 28px 4px 10px;
          font-size: 12px;
          color: #1a2332;
          background: #f8fafc;
          outline: none;
          cursor: pointer;
        }
        .eh-cal-icon {
          position: absolute;
          right: 8px;
          font-size: 12px;
          pointer-events: none;
        }
        .eh-nav {
          display: flex;
          align-items: center;
          gap: 2px;
          flex: 1;
          justify-content: center;
        }
        .eh-nav-item-wrap {
          position: relative;
          display: flex;
          align-items: center;
        }
        .eh-nav-item {
          padding: 6px 12px;
          font-size: 13px;
          font-weight: 500;
          color: #4a5568;
          cursor: pointer;
          border-radius: 4px;
          text-decoration: none;
          white-space: nowrap;
          transition: color 0.15s;
          border-bottom: 2px solid transparent;
        }
        .eh-nav-item:hover {
          color: #1a73e8;
        }
        .eh-nav-item.active {
          color: #1a73e8;
          font-weight: 700;
          border-bottom: 2px solid #1a73e8;
        }
        .eh-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          min-width: 16px;
          height: 16px;
          border-radius: 8px;
          font-size: 9px;
          font-weight: 700;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 4px;
        }
        .eh-right {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-shrink: 0;
        }
        .eh-cnt-badge {
          min-width: 26px;
          height: 26px;
          border-radius: 13px;
          font-size: 11px;
          font-weight: 700;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 6px;
        }
        .eh-cnt-red { background: #ef4444; }
        .eh-cnt-yellow { background: #f59e0b; }
        .eh-utc {
          font-size: 12px;
          font-weight: 600;
          color: #4a5568;
          white-space: nowrap;
        }
      `}</style>
    </div>
  );
}
